// ============================================================
// EmailDeliveryNote.js
// One line under an invitation saying whether its latest email
// arrived. Errors carry the raw provider reason in a <details> so an
// operator can quote it to the recipient's IT without it cluttering
// the row. See utils/emailDelivery.js for why this exists.
// ============================================================
import React from 'react';
import { describeEmailDelivery } from '../utils/emailDelivery';
import './EmailDeliveryNote.css';

export default function EmailDeliveryNote({ lastEmail, className = '' }) {
  const d = describeEmailDelivery(lastEmail);
  if (!d) return null;
  return (
    <div className={`email-delivery-note email-delivery-note--${d.tone} ${className}`.trim()}>
      <span>{d.text}</span>
      {d.detail && (
        <details className="email-delivery-note__detail">
          <summary>Details</summary>
          <code>{d.detail}</code>
        </details>
      )}
    </div>
  );
}
